import { EuiSpacer } from '@elastic/eui';
import VideoCard from "../../../../src/components/Products/IN-LAN/video-in-lan-500";
import * as React from 'react';
export default {
  EuiSpacer,
  VideoCard,
  React
};